document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper");

  function toggleHeader() {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  window.addEventListener("scroll", toggleHeader);



  const description = document.getElementById("productDescription");
  if (!description) return;

  const paragraphs = description.querySelectorAll("p");

  if (paragraphs.length <= 1) return;

  let currentIndex = 1;

  // Hide all except first
  for (let i = 1; i < paragraphs.length; i++) {
    paragraphs[i].style.display = "none";
  }

  // Create button
  const button = document.createElement("button");
  button.className = "read-more-btn";
  button.innerText = "Read More";

  description.appendChild(button);

  button.addEventListener("click", function() {

    if (currentIndex < paragraphs.length) {
      paragraphs[currentIndex].style.display = "block";
      paragraphs[currentIndex].style.opacity = "0";
      paragraphs[currentIndex].style.transform = "translateY(10px)";

      setTimeout(() => {
        paragraphs[currentIndex].style.opacity = "1";
        paragraphs[currentIndex].style.transform = "translateY(0)";
      }, 50);

      currentIndex++;
    }

    if (currentIndex === paragraphs.length) {
      button.innerText = "Show Less";
    }

    if (currentIndex > paragraphs.length) {
      // Reset back to first
      for (let i = 1; i < paragraphs.length; i++) {
        paragraphs[i].style.display = "none";
      }
      currentIndex = 1;
      button.innerText = "Read More";
    }

  });


});
